declare module 'axios' {
  export interface AxiosRequestConfig {
    /**
     * @description Removes default error handler for specified status codes
     */
    suppressErrorHandler?: number[]
  }
}

export interface RequestById {
  id: number
}

export type Response<T = void> = {
  data: T
}

export type TableResponse<T> = {
  data: {
    rows: T[]
    count: number
    publishedCount?: number
    countOfArticles?: number
    countOfLinkedArticles?: number
    countOfLinkedPublishedArticles?: number
    countOfPublishedArticles?: number
    linkedArticlesCount?: number
  }
}

export interface ApiSuccessResponse {
  success: boolean
}

export enum EOp {
  contains = 'contains',
  notContains = 'notContains',
  equals = 'equals',
  notEqual = 'notEqual',
  startsWith = 'startsWith',
  endsWith = 'endsWith',
  blank = 'blank',
  notBlank = 'notBlank',
  lessThan = 'lessThan',
  lessThanOrEqual = 'lessThanOrEqual',
  greaterThan = 'greaterThan',
  greaterThanOrEqual = 'greaterThanOrEqual',
  inRange = 'inRange',
  notInRange = 'notInRange',
  in = 'in',
  notIn = 'notIn',
  overlap = 'overlap',
}
